module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/worker/worker-dashboard/worker-dashboard.component.scss
// module id = ./src/app/worker/worker-dashboard/worker-dashboard.component.scss
// module chunks = main